import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface SaveListDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  listName: string;
  onListNameChange: (value: string) => void;
  listDescription: string;
  onListDescriptionChange: (value: string) => void;
  contactCount: number;
  onSave: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  trigger?: React.ReactNode;
  disabled?: boolean;
}

export function SaveListDialog({
  isOpen,
  onOpenChange,
  listName,
  onListNameChange,
  listDescription,
  onListDescriptionChange,
  contactCount,
  onSave,
  onCancel,
  isLoading = false,
  trigger,
  disabled = false,
}: SaveListDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild disabled={disabled}>{trigger}</DialogTrigger>}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Save Contact List</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            placeholder="List name"
            value={listName}
            onChange={(e) => onListNameChange(e.target.value)}
          />
          <Textarea
            placeholder="Description (optional)"
            value={listDescription}
            onChange={(e) => onListDescriptionChange(e.target.value)}
          />
          <p className="text-sm text-muted-foreground">
            This will save {contactCount} contact{contactCount !== 1 ? 's' : ''} with current filters applied.
          </p>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onCancel}>Cancel</Button>
            <Button onClick={onSave} disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save List'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}


